import { Hub, BrowserClient } from '@sentry/browser';
import axios from 'axios';
import { RELEASE_ENVIRONMENT, BETA_ENVIRONMENT, PROD_ENVIRONMENT } from '../utils/common-types.js';
import { CURRENT_SITE_DOMAIN } from '../utils/site-utils.js';

const MOCKED_HUB = {
    captureException: (exception) => {
        console.error('Captured mocked Sentry error: ', exception);
    },
};
let hub;
const dsn = 'https://f43471b2d7a14e00821cbc9993b8145e@o354215.ingest.sentry.io/6512149';
const makeRealHub = (deploymentEnv) => {
    // See Wiki for more information about Sentry: https://wiki.web.zooplus.de/display/PD/Sentry
    const realHub = new Hub(new BrowserClient({
        dsn,
        release: getReleaseVersion(),
        environment: deploymentEnv,
        beforeSend(event) {
            if (event.tags?.dsn !== dsn) {
                return null;
            }
            delete event.tags?.dsn;
            return event;
        },
    }));
    realHub.configureScope((scope) => {
        scope.setTags({ dsn, domain: CURRENT_SITE_DOMAIN });
    });
    console.log('Sentry configured with dsn', dsn, 'and environment', deploymentEnv);
    return realHub;
};
const getReleaseVersion = () => {
    return process.env.REACT_APP_RELEASE_VERSION || '';
};
const isEligibleEnv = (deploymentEnv) => {
    if (!deploymentEnv)
        return false;
    return [RELEASE_ENVIRONMENT, BETA_ENVIRONMENT, PROD_ENVIRONMENT].includes(deploymentEnv);
};
const initializeSentry = (deploymentEnv) => {
    hub = isEligibleEnv(deploymentEnv) ? makeRealHub(deploymentEnv) : MOCKED_HUB;
};
const withSentryHub = () => {
    return hub ? hub : MOCKED_HUB;
};
const sendErrorToSentry = (error) => {
    if (axios.isAxiosError(error)) {
        const { status, data } = error?.response || {};
        if (status === 400 && typeof data === 'string' && data.includes('validationErrors')) {
            return;
        }
        else if (status === 401) {
            return;
        }
    }
    withSentryHub().captureException(error);
};

export { initializeSentry, isEligibleEnv, sendErrorToSentry, withSentryHub };
//# sourceMappingURL=sentry-service.js.map
